<template>
	<div class="page_warp">
		<div class="top_content">
			<div class="top_input">
				<el-input placeholder="请输入"></el-input>
			</div>
			<div class="search_btn" @click="getData">查询</div>
			<div class="add_btn" @click="add" v-if="permissionItem.add">添加</div>
		</div>
		<div class="bottom_content">
			<div class="table_container" v-bind:id="tableId">
				<el-table v-bind:data="tableData" stripe border style="width: 100%" v-bind:max-height="tableHeight"
					v-bind:header-cell-style="{
            textAlign: 'center',
            color: '#333333',
            background: '#F5F5F5',
          }" v-bind:cell-style="{ textAlign: 'center' }" empty-text="暂无数据">
					<el-table-column prop="orgLogo" width="120" label="机构LOGO">
						<template #default="scope">
							<div class="table-row-img" style="background: #e5e5e5">
								<img v-if="scope.row.orgLogo" v-bind:src="scope.row.orgLogo" alt="" />
								<img v-else src="@/assets/images/icon-user-bg.png" alt="" />
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="orgId" label="机构编号"></el-table-column>
					<el-table-column prop="orgName" label="机构名称"></el-table-column>
					<el-table-column prop="orgType" label="机构类型"></el-table-column>
					<el-table-column prop="userLgname" label="系统用户"></el-table-column>
					<el-table-column label="机构状态">
						<template #default="scope">
							<el-switch :value="scope.row.orgStatusBoolen" active-text="正常" inactive-text="禁用"
								@change="updateState(scope.row)">
							</el-switch>
						</template>
					</el-table-column>
					<el-table-column prop="orgContact" label="联系人"></el-table-column>
					<el-table-column prop="orgPhone" label="电话"></el-table-column>
					<el-table-column prop="orgAddr" label="详细地址"></el-table-column>
					<el-table-column prop="orgCretime" label="创建时间"></el-table-column>
					<el-table-column label="操作">
						<template #default="scope">
							<span v-if="permissionItem.edit" class="default_color pointer m-right10"
								v-on:click="edit(scope.row.orgId)">编辑</span>
							<span v-if="permissionItem.list" class="default_color pointer m-right10"
								v-on:click="detail(scope.row.orgId)">详情</span>
							<span v-if="permissionItem.del" class="col-FF1A1A pointer m-right10"
								v-on:click="del(scope.row.orgId)">删除</span>
							<span v-if="permissionItem.edit" class="default_color pointer"
								v-on:click="resetMm(scope.row)">重置密码</span>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="flex flex-y-center flex-x-center">
				<el-config-provider :locale="locale">
					<el-pagination background v-model:currentPage="page" v-model:page-size="pageSize"
						:page-sizes="[5, 10, 15, 20]" layout="sizes, prev, pager, next, total, jumper"
						:total="totalCount" @size-change="getData" @current-change="getData" />
				</el-config-provider>
			</div>
		</div>

		<Add ref="addRef" v-if="isAdd" @getData="getData" />
		<Edit ref="editRef" v-if="isEdit" @getData="getData" />
		<Detail ref="detailRef" v-if="isDetail" @getData="getData" />
		<!-- <div class="menuManagemen" v-if="isAdd">
      <Add :sendData="sendData" @closeModal="closeModal" @getData="getData" />
    </div>
    <div class="menuManagemen" v-if="isEdit">
      <Edit :sendData="sendData" @closeModal="closeModal" @getData="getData" />
    </div>
    <div class="menuManagemen" v-if="isDetail">
      <Detail
        :sendData="sendData"
        @closeModal="closeModal"
        @getData="getData"
      />
    </div> -->
	</div>
</template>

<script>
	import {
		computed,
		defineComponent,
		reactive,
		toRefs,
		nextTick,
		onMounted,
		getCurrentInstance,
	} from "vue";
	import {
		useStore
	} from "vuex";
	import {
		apiObj
	} from "@/config/api";
	import Add from "./components/add";
	import Edit from "./components/edit";
	import Detail from "./components/detail";
	import zhCn from "element-plus/es/locale/lang/zh-cn";
	export default defineComponent({
		components: {
			Add,
			Edit,
			Detail
		},
		name: "orgManage",
		setup() {
			const store = useStore();
			const {
				proxy
			} = getCurrentInstance();

			const data = reactive({
				tableId: "orgManagementTable",
				page: 1,
				pageSize: 10,
				searchWord: "",
				totalCount: 0,
				tableData: [],
				tableHeight: 0,
				isAdd: false,
				isEdit: false,
				isDetail: false,
				sendData: null,
				locale: zhCn,

				permissionItem: {
					list: false,
					add: false,
					edit: false,
					del: false,
				},
			});
			onMounted(() => {
				let perms = proxy.$storage.get("perms");
				perms.forEach((el) => {
					if (el == "orgManage:list") {
						data.permissionItem.list = true;
					}
					if (el == "orgManage:add") {
						data.permissionItem.add = true;
					}
					if (el == "orgManage:edit") {
						data.permissionItem.edit = true;
					}
					if (el == "orgManage:del") {
						data.permissionItem.del = true;
					}
				});

				console.log(store.state.userInfo);
				nextTick(() => {
					data.tableHeight =
						document.querySelector(
							".bottom_content .table_container#" + data.tableId
						).offsetHeight - 40;
					getData();
				});
				window.onresize = () => {
					nextTick(() => {
						var offsetHeight = document.querySelector(
							".bottom_content .table_container#" + data.tableId
						).offsetHeight;
						if (offsetHeight <= 0) {
							return false;
						}
						data.tableHeight = document.querySelector(
							".bottom_content .table_container#" + data.tableId
						).offsetHeight;
					});
				};
			});
			//获取列表数据
			const getData = async () => {
				if (!data.permissionItem.list) {
					proxy.$message.error("没有查询机构列表权限！");
					return;
				}

				let params = {
					searchWord: data.searchWord,
					page: data.page,
					limit: data.pageSize,
					// roleOrg: store.state.userInfo.orgId,
				};
				const r = await proxy.$http.get(apiObj.orgList, params);
				console.log(r);
				if (r.code === 0) {
					r.rows.forEach((el) => {
						el.orgStatusBoolen = el.orgStatus == 0 ? true : false;
					});
					data.tableData = r.rows;
					data.totalCount = r.total;
				}
			};

			// 添加 根目录
			const add = () => {
				if (!data.permissionItem.add) {
					proxy.$message.error("没有机构添加权限！");
					return;
				}

				data.isAdd = true;
				nextTick(() => {
					proxy.$refs.addRef.init();
				});
			};

			// 菜单编辑
			const edit = (id) => {
				if (!data.permissionItem.edit) {
					proxy.$message.error("没有机构编辑权限！");
					return;
				}

				data.isEdit = true;
				nextTick(() => {
					proxy.$refs.editRef.init(id);
				});
			};
			// 菜单详情
			const detail = (id) => {
				if (!data.permissionItem.list) {
					proxy.$message.error("没有机构查询权限！");
					return;
				}

				data.isDetail = true;
				nextTick(() => {
					proxy.$refs.detailRef.init(id);
				});
			};
			//菜单删除
			const del = (orgId) => {
				if (!data.permissionItem.del) {
					proxy.$message.error("没有机构删除权限！");
					return;
				}

				proxy
					.$confirm("您确定删除选中的数据吗", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
					})
					.then(async () => {
						let params = {
							orgId: orgId,
						};
						const r = await proxy.$http.postFormData(apiObj.orgDel, params);
						if (r.respCode == 0 || r.respCode == "0000") {
							proxy.$message.success(r.msg || r.respMsg);
							getData();
						} else {
							proxy.$message.error(r.msg || r.respMsg);
						}
					});
			};

			const updateState = (row) => {
				if (!data.permissionItem.edit) {
					proxy.$message.error("没有机构编辑权限！");
					return;
				}

				proxy.$confirm(
					`您确定执行${!row.orgStatusBoolen ? "启用" : "禁用"}操作，是否继续?`,
					"提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
					}
				).then(async () => {
					proxy.$http
						.postFormData(
							"/admin/bdzl/org/modifyState", {
								orgId: row.orgId,
								status: row.orgStatusBoolen ? 1 : 0
							}, {
								headers: {
									"Content-Type": "application/x-www-form-urlencoded"
								},
							}
						)
						.then((res) => {
							if (res.code == 0 || res.respCode == "0000") {
								proxy.$message.success(res.msg || res.respMsg);
								getData();
							} else {
								proxy.$message.info(res.msg || res.respMsg);
							}
						});
				});
			};

			const resetMm = (row) => {
				if (!data.permissionItem.edit) {
					proxy.$message.error("没有机构编辑权限！");
					return;
				}

				var val = row.orgId;
				proxy.$confirm(
					"您确定将" +
					row.orgName +
					"(" +
					row.userLgname +
					")重置密码为‘123456’吗?",
					"提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
					}
				).then(() => {
					proxy.$http
						.postFormData(
							"/admin/bdzl/org/resetPwd", {
								orgId: val
							}, {
								headers: {
									"Content-Type": "application/x-www-form-urlencoded"
								},
							}
						)
						.then((res) => {
							if (res.code == 0 || res.respCode == "0000") {
								proxy.$message.success(res.msg || res.respMsg);
							} else {
								proxy.$message.info(res.msg || res.respMsg);
							}
						});
				});
			};

			return {
				...toRefs(data),
				getData,
				add,
				edit,
				detail,
				del,
				updateState,
				resetMm,
			};
		},
	});
</script>

<style scoped>
	.page_warp {
		width: 100%;
		height: 100%;
	}

	.table-row-img {
		width: 60px;
		height: 60px;
		border-radius: 50%;
		display: inline-block;
	}

	.table-row-img img {
		width: 60px;
		height: 60px;
		border-radius: 50%;
	}
</style>